





















































import cartLine from 'library/mixins/cart-line'
import SubscriptionIntervalSelector from 'library/components/globals/subscription-interval-selector'

import 'vue-height-tween-transition/index.css'
import HeightTween from 'vue-height-tween-transition'

export default

	components: { HeightTween, SubscriptionIntervalSelector }

	mixins: [ cartLine ]

	computed:
		subscribeAndSave: ->
			if @subscriptionDiscount != "0%"
				"SUBSCRIBE & SAVE (#{@subscriptionDiscount})"
			else "SUBSCRIBE"

